import { __extends } from "tslib";
import { RenderTargetTexture } from '../Textures/renderTargetTexture';
import { InternalTextureSource } from '../Textures/internalTexture';
/**
 * Renders to multiple views with a single draw call
 * @see https://www.khronos.org/registry/webgl/extensions/WEBGL_multiview/
 */
var MultiviewRenderTarget = /** @class */ (function (_super) {
    __extends(MultiviewRenderTarget, _super);
    /**
     * Creates a multiview render target
     * @param scene scene used with the render target
     * @param size the size of the render target (used for each view)
     */
    function MultiviewRenderTarget(scene, size) {
        if (size === void 0) { size = 512; }
        var _this = _super.call(this, "multiview rtt", size, scene, false, true, InternalTextureSource.Unknown, false, undefined, false, false, true, undefined, true) || this;
        var internalTexture = scene.getEngine().createMultiviewRenderTargetTexture(_this.getRenderWidth(), _this.getRenderHeight());
        internalTexture.isMultiview = true;
        internalTexture.format = 5;
        _this._texture = internalTexture;
        _this.samples = _this._getEngine().getCaps().maxSamples || _this.samples;
        return _this;
    }
    /**
     * @hidden
     * @param faceIndex the face index, if its a cube texture
     */
    MultiviewRenderTarget.prototype._bindFrameBuffer = function (faceIndex) {
        if (faceIndex === void 0) { faceIndex = 0; }
        if (!this._texture) {
            return;
        }
        this.getScene().getEngine().bindMultiviewFramebuffer(this._texture);
    };
    /**
     * Gets the number of views the corresponding to the texture (eg. a MultiviewRenderTarget will have > 1)
     * @returns the view count
     */
    MultiviewRenderTarget.prototype.getViewCount = function () {
        return 2;
    };
    return MultiviewRenderTarget;
}(RenderTargetTexture));
export { MultiviewRenderTarget };
//# sourceMappingURL=MultiviewRenderTarget.js.map